import { createSelector } from 'reselect';

import getHasSearchedLocation from '@location/selectors/getHasSearchedLocation';
import getCartHasItems from '@core/reducers/cart/selectors/getCartHasItems';
import getHasCart from '@core/reducers/cart/selectors/getHasCart';
import getUserClosedNoLocationPointToast from './getUserClosedNoLocationPointToast';

const getShowNoLocationPointToast = createSelector(
  getHasSearchedLocation,
  getHasCart,
  getCartHasItems,
  getUserClosedNoLocationPointToast,
  (hasLocation, hasCart, cartHasItems, userClosed) =>
    !hasLocation && hasCart && !cartHasItems && !userClosed,
);

export default getShowNoLocationPointToast;
